export default "__VITE_ASSET__q8Q4YgK0__"